import * as React from 'react';
import treadmill from "../../assets/icon/treadmill.gif";
import treadmillRun from "../../assets/icon/treadmillRun.gif";
import careStore from "../../store/careStore";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Avatar from '@mui/material/Avatar';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {useEffect} from "react";


const CareLose = () => {
  const storeData: any = careStore()
  
  useEffect(() => {
    return () => {
      storeData.setCareInfo('food', 0);
    }
  }, []);
  
  // 선택 항목 클릭 이벤트
  const handleCheckedBoxes = (e :any) => {
    const targetName = e.target.name;
    if(e.target.checked){
      storeData.setCareInfo('goal', targetName);
    }else{
      storeData.setCareInfo('goal', 0);
    }
  };
 
  
  
  return (
    <Stack  sx={{ width: '100%', minWidth:320, background:'#F1F2F4'}} spacing={2}>

        <Grid sx={{bgcolor:'#fff', p:0, pt:2,pb:3, width:'100%',minHeight:515  }}>
          <Box sx={{boxSizing: 'border-box',}}>
          <Typography  component="div" sx={{fontSize:18, pb:1, color:'#555', m:4, mb:0, textAlign:'center'}}>
            체중 감량이 필요한 경우<br /> 1주일에 몇 Kg까지 감량을 원하시나요?
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row', p:1,
              margin:' 0 auto',
              boxSizing: 'border-box',
              justifyContent:'center',
              '& .MuiFormControlLabel-root': {}
            }}
      >
            <FormGroup sx={{p:0, justifyContent:"center"}} aria-label="position" row >
              <Stack flexDirection={'row'} >
                <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                  <Avatar alt="" src={treadmill} sx={{m:'10px auto'}} variant="square" />
                  <FormControlLabel sx={{m:0}} control={
                    <Checkbox onClick={handleCheckedBoxes} name="0.5" checked={storeData.careInfo.goal === '0.5' || storeData.careInfo.goal === ''}
                      icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                      
                      sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                        color: '#3ecbca',
                      },  }} />} 
                      label="0.5kg(한달 2kg)"  
                      labelPlacement="top" 
                    />
                </Box>

                <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                  <Avatar alt="" src={treadmillRun} sx={{ m:'10px auto'}} />
                  <FormControlLabel sx={{m:0}} control={
                    <Checkbox onClick={handleCheckedBoxes} name="1" checked={storeData.careInfo.goal === '1'}
                      icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                      
                      sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                        color: '#3ecbca',
                      },  }} />} 
                      label="1kg (한달 4kg)"  
                      labelPlacement="top" 
                    />
                </Box>
              </Stack>
            </FormGroup>
          </Box>
            
          </Box>
      </Grid>

    </Stack >
  );
}

export default CareLose;